import TablaYounet from '../Elementos/TablaYounet';


const Element =()=>{

    const headCellsColumn = [
        { id: 'Banco', numeric: false, disablePadding: false, label: 'BANCO', show:true, fixed:false, width:400, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
    ];

    const variablesObject = {
        api:'/api/Bancos',
        apiMultiples:'/api/Bancos/multiple',
        isButtonAdd:true,
        isMultiline:false,
        isUpperCase:false,
        label:'BANCO',  
        nameLocalStorage:'headersBancosYounet',
        order:'asc',
        orderBy:'Banco',
        rowsPerPage:15,
        sumWidth:560,
        title:'BANCOS',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Element;